import React, { useState } from 'react';

interface TabPillsProps {
  options: string[];
  value: string;
  onValueChange: (value: string) => void;
  badges?: Partial<Record<string, number>>;
}

const TabPills = ({ options = [], value, onValueChange, badges }: TabPillsProps) => {
  return (
    <div className="flex items-center gap-3 flex-wrap">
      {options.map((option) => (
        <button
          key={option}
          className={`text-sm md:text-base py-1 px-3 rounded-full border border-[#E2E8F0] bg-lightPurple-200 hover:bg-lightPurple-300/60 cursor-pointer inline-flex items-center gap-2 ${value === option ? 'bg-primary text-white hover:!bg-primary' : ''}`}
          onClick={() => onValueChange(option)}
        >
          <span>{option}</span>
          {badges?.[option] != null && badges[option]! > 0 && (
            <span
              className={`inline-flex min-w-[18px] h-[18px] items-center justify-center rounded-full text-[10px] font-semibold leading-none ${
                value === option ? 'bg-white text-primary' : 'bg-primary text-white'
              }`}
            >
              {badges[option]}
            </span>
          )}
        </button>
      ))}
    </div>
  );
};

export default TabPills;
